import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Constants } from '../../constants';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

@Component({
  selector: 'app-update-forgotten-password',
  templateUrl: './update-forgotten-password.component.html',
  styleUrls: ['./update-forgotten-password.component.css']
})
export class UpdateForgottenPasswordComponent implements OnInit, OnDestroy {

    token: string;
    id: string;
    subscription: Subscription;
    updatePassword: FormGroup;
    constructor(private _fb: FormBuilder,
                private route: ActivatedRoute,
              private _http: Http,
                private dialog: MatDialog) {
        this.updatePassword = this._fb.group({
            newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
            confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)])
        });
    }

  ngOnInit() {

      this.subscription = this.route.params.subscribe(params => {
        console.log(params);
      this.token = params[Constants.TOKEN];
      this.id = params[Constants.ID];
    }
      );
  }
    ngOnDestroy(){
        this.subscription.unsubscribe();
    }

    onSubmit(){
        const passwordData= this.setupPasswordData();

        const updatePasswordEndpoint = Constants.NEXPRESS_ENDPOINT + 'Account/ResetPassword';
    const headers = new Headers({
      'Content-Type': 'application/JSON'
    });
    const options = new RequestOptions({headers: headers});
        this._http.post(updatePasswordEndpoint, passwordData, options)
            .map((response) => response.json())
            .subscribe(
            result => {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        title: 'Success',
                        message: 'You have successfully updated your password',
                        alertType: 'success'
                    }
                });
                console.log('Success', result);
                this.updatePassword.reset();

            },
            error => {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        title: 'Error',
                        message: error,
                        alertType: 'danger'
                    }
                });
            });

    }

    private setupPasswordData(){
        return {
            'Email': this.id,
            'Token': this.token,
            'NewPassword':this.updatePassword.value.newPassword,
            'ConfirmPassword':this.updatePassword.value.confirmPassword
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-forgotten-password/update-forgotten-password.component.ts